<template>
	<div class="page pageContainer">
		<div class="nav">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>基础数据</el-breadcrumb-item>
				<el-breadcrumb-item>其他配置</el-breadcrumb-item>

			</el-breadcrumb>
			<div style="position: absolute; top: 0; right: 0;">
				<el-button type="primary" size="small" @click="addNew">添加缴费项</el-button>
			</div>

		</div>


		<el-form ref="form" :model="dataview" label-width="120px">
			
			<el-row :gutter="20" >
				<el-col :span="15">
					<el-form-item label="可查看数据时间">
						
						 <el-date-picker
						      v-model="dataview.kvalue"
							  value-format="yyyy-MM-dd"
						      type="daterange"
						      range-separator="至"
						      start-placeholder="开始日期"
						      end-placeholder="结束日期">
						    </el-date-picker>
							
							<el-button type="primary"  style="margin-left: 10px;" icon="el-icon-s-claim" @click="updateItem()">保存</el-button>
					</el-form-item>
				</el-col>
				
			</el-row>




			<el-form-item>

			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dataview: {
					id: 0,
					kvalue:[]
				},
				DataList: []
			}
		},
		mounted() {
			this.getList()

		},
		methods: {
			getList() {
				this.$http.post("/api/sys_platform_config_list", {
				ktype:"ktype",
				keyword:"data_exprise",
				sch_id:this.$store.state.pmid
				}).then(res => {
					if(res.data.data.length>0){
						let dataview = res.data.data[0]
						if(dataview.kvalue){
							dataview.kvalue = JSON.parse(dataview.kvalue)
						}else{
							dataview.kvalue = []
						}
						this.dataview =  dataview
						this.$nextTick(()=>{
							this.$forceUpdate()
						})
					}
				
				})
			},
			updateItem() {
				let dataview = this.dataview
				dataview.kvalue = JSON.stringify(dataview.kvalue )
				this.$http.post("/api/sys_platform_config_edit", dataview).then(res => {
					this.getList()
					this.$message({
						type: 'success',
						message: '保存成功'
					});
				})
			},
			deleteItem(item) {

				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/t_sch_cost_delete", {
						id: item.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功'
						});

						this.getList();
					})

				}).catch(() => {

				});
			},
			addNew() {
				this.DataList.push({
					id: 0,
					fee_code: "",
					fee_value: "",
					fee_name: "",
					fee_price: "",
					remark: ""
				})
			}
		}
	}
</script>

<style>
</style>
